import {createReducer} from '@reduxjs/toolkit';
import {setLabStatus} from '@src/actions/labs.js';
import {LABS_DEFAULT, LABS_KEY} from '@src/constants';
import {get as getStored} from '@src/utils/store.js';

const initialState = {
  ...LABS_DEFAULT,
  ...getStored(LABS_KEY),
};

const labs = createReducer(initialState, builder => {
  builder.addCase(setLabStatus, (state, {payload}) => {
    state[payload.labKey] = payload.enabled;
  });
});

export default labs;
